<script>
    import { navigateTo } from 'svelte-router-spa'
    import { covidContact, supsectContact, travelAbroad } from '../../store.js'

    let exposures = {
        covidContact: {
            name: 'Have you worked together or stayed in the same close environment of a confirmed COVID-19 case?',
            fil: 'May nakasama ka ba o nakatrabahong tao na kumpirmadong may COVID-19/may impeksyon ng coronavirus?'
        },
        supsectContact: {
            name: 'Have you had any contact with anyone with fever, cough, colds, and sore throat in the past 2 weeks?',
            fil: 'Mayroon ka bang nakasama na may lagnat, ubo, sipon, o sakit ng lalamunan sa nakalipas na dalawang (2) linggo?'
        },
        travelAbroad: {
            name: 'Have you travelled outside of the Philippines in the past 14 days?',
            fil: 'Ikaw ba ay nagbyahe sa labas ng Pilipinas sa nakalipas na 14 na araw?'
        }
    }
    
    let current = 'covidContact'
    let display = exposures.covidContact

    function nxt(answer) {
         if (current === 'covidContact') {
            covidContact.set(answer)
            current = 'suspectContact'
            display = exposures.supsectContact
        } else if (current === 'suspectContact') {
            supsectContact.set(answer)
            current = 'travelAbroad'
            display = exposures.travelAbroad
        } else if (current === 'travelAbroad') {
            travelAbroad.set(answer)
            navigateTo('travelCity')
        }
    }

</script>

<main>
    <div class="body">
        <h2>{display.name}</h2>
        <p>{display.fil}</p>        
        <a class="btn" on:click={() => nxt('YES')}>
            <span class="e">Yes</span>
            <span class="f">Oo</span>
        </a>
        <a class="btn" on:click={() => nxt('NO')}>
            <span class="e">No</span>
            <span class="f">Hindi</span>
        </a>
    </div>
</main>

<style>

</style>